import styled from 'styled-components';

type BadgeProps = {
    $isCurrent: boolean;
};

export const CardShopWrapper = styled.div`
    width: 100%;
    border-radius: 0.75rem;
    padding: 0.75rem;
    gap: 1rem;
    display: flex;
    align-items: center;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
    justify-content: space-between;
    align-self: stretch;

    @media (max-width: 768px) {
        gap: 0.75rem;
    }
`;

export const VideoScreen = styled.img`
    height: 100%;
    width: 7.375rem;
    border-radius: 6px;
    @media (max-width: 768px) {
        display: none;
    }
`;

export const DetailsShopWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: start;
    flex-direction: column;
    gap: 0.3rem;
    flex: 1;

    h3 {
        font-size: 1.25rem;
        line-height: 1rem;
        font-weight: 800;
        margin: 0;
    }

    span {
        font-size: 0.875rem;
        line-height: 1rem;
        font-weight: 500;
    }

    section {
        display: flex;
        justify-content: center;
        align-items: center;

        gap: 0.25rem;
    }

    @media (max-width: 768px) {
        h3 {
            font-size: 1rem;
        }

        span {
            font-size: 0.7rem;
        }
    }
`;

export const BadgeWrapper = styled.div`
    display: flex;
    align-items: start;
    justify-content: start;
    gap: 0.75rem;
    flex-wrap: wrap;
`;

export const BadgeHour = styled.div<BadgeProps>`
    outline: solid 2px
        ${({ theme, $isCurrent }) => {
            return $isCurrent
                ? theme.colors['supernova-500']
                : theme.colors['silver-100'];
        }};
    border-radius: 0.75rem;
    display: flex;
    padding: 0.25rem 0.5rem;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
    font-size: 1rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1rem;

    width: 7rem;

    cursor: pointer;
    background-color: ${({ theme, $isCurrent }) => {
        return $isCurrent ? theme.colors['supernova-100'] : 'transparent';
    }};
`;

export const ButtonShop = styled.button`
    background-color: ${({ theme }) => theme.colors['silver-100']};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    padding: 0.25rem 0.5rem;
    cursor: pointer;
    border-radius: 0.5rem;
    border: transparent;

    font-size: 1.25rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.5rem;
`;

export const HoursElementsText = styled.span`
    color: ${({ theme }) => theme.colors['neutral-500']};

    font-size: 0.75rem;
    font-weight: 500;
`;

export const WrapHourDescription = styled.div`
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: flex-start;

    gap: 0.625rem !important;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;
